import * as stores from '@/store'

export default () => {
  const { $pinia } = useNuxtApp()
  return {
    theme: stores.theme($pinia),
    auth: stores.auth($pinia),
    system: stores.system($pinia),
    data: stores.data($pinia),
    library: stores.library($pinia),
    userConfig: stores.userConfig($pinia),
    globalSettings: stores.globalSettings($pinia),
    vehicleDataTable: stores.vehicleDataTable($pinia),
    cooperatorDataTable: stores.cooperatorDataTable($pinia),
    driverDataTable: stores.driverDataTable($pinia),
    nodeDataTable: stores.nodeDataTable($pinia),
    taskDataTable: stores.taskDataTable($pinia),
    businessDataTable: stores.businessDataTable($pinia),
    nodeTypeDataTable: stores.nodeTypeDataTable($pinia),
    notification: stores.notification($pinia),
    dataTable: stores.dataTable($pinia),
    bookingDataTable: stores.bookingDataTable($pinia),
    workflowDataTable: stores.workflowDataTable($pinia),
    costDataTable: stores.costDataTable($pinia),
    connectDataTable: stores.connectDataTable($pinia),
    quoteDataTable: stores.quoteDataTable($pinia),
    priceDataTable: stores.priceDataTable($pinia),
    orderDataTable: stores.orderDataTable($pinia),
    routeDataTable: stores.routeDataTable($pinia),
    tripDataTable: stores.tripDataTable($pinia),
    companyGroupDataTable: stores.companyGroupDataTable($pinia),
    companyUserDataTable: stores.companyUserDataTable($pinia),
    report: stores.report($pinia),
    reportFilter: stores.reportFilter($pinia),
    systemAlert: stores.systemAlert($pinia),
    monitoringPage: stores.monitoringPage($pinia),
    reportPage: stores.reportPage($pinia),
    distributingPage: stores.distributingPage($pinia),
    map: stores.map($pinia),
    vehicleGps: stores.vehicleGps($pinia),
    bankAccountDataTable: stores.bankAccountDataTable($pinia),
    sellingPriceDataTable: stores.sellingPriceDataTable($pinia),
    guest: stores.guest($pinia)
  }
}
